import React from 'react';
import { PackageCheckIcon } from 'lucide-react';
interface OrderItem {
  id: number;
  name: string;
  price: number;
  quantity: number;
  image: string;
}
interface NowCheckoutOrderSummaryProps {
  items: OrderItem[];
  subtotal: number;
  discount: number;
  shippingCost: number;
  tax: number;
  total: number;
}
export function NowCheckoutOrderSummary({
  items,
  subtotal,
  discount,
  shippingCost,
  tax,
  total
}: NowCheckoutOrderSummaryProps) {
  return <section className="overflow-hidden rounded-xl border border-brand-border bg-white" aria-labelledby="now-order-summary-title" data-id="element-1655" data-mp="pzuv8izzodii">
      <header className="border-b border-brand-border px-3 py-3" data-id="element-1656" data-mp="gyn6arjd4p13">
        <div className="flex items-center justify-between gap-3" data-id="element-1657" data-mp="h0hh3d0x70rg"><h2 id="now-order-summary-title" className="text-sm font-bold text-brand-ink" data-id="element-1658" data-mp="lwoozbcvmmc1">Order summary</h2><span className="text-base font-bold text-brand" data-id="element-1659" data-mp="31ocjl04f42ro">SAR {total.toFixed(2)}</span></div>
        <div className="mt-2 space-y-1.5 text-xs" data-id="element-1660" data-mp="36o8fec2yonw5">
          <div className="flex justify-between text-brand-muted" data-id="element-1661" data-mp="36p073btfu1h5"><span data-id="element-1662" data-mp="1lrmehdxw653g">Subtotal</span><span data-id="element-1663" data-mp="1lt79t5s15s2d">SAR {subtotal.toFixed(2)}</span></div>
          {discount > 0 && <div className="flex justify-between text-emerald-700" data-id="element-1664" data-mp="1gtuk8d9ry6w3"><span data-id="element-1665" data-mp="1gvfhwbrdy5y6">Discount</span><span data-id="element-1666" data-mp="1vqln4winq0qg">−SAR {discount.toFixed(2)}</span></div>}
          <div className="flex justify-between text-brand-muted" data-id="element-1667" data-mp="1vs6j8qkmdrqf"><span data-id="element-1668" data-mp="1qrs7axfwdxn4">Shipping &amp; handling</span><span className={shippingCost === 0 ? 'font-semibold text-emerald-700' : 'text-brand-ink'} data-id="element-1669" data-mp="1qqpj4x9ym9aw">{shippingCost === 0 ? 'Free' : `SAR ${shippingCost.toFixed(2)}`}</span></div>
          <div className="flex justify-between text-brand-muted" data-id="element-1670" data-mp="1zsyt9m1bg0nr"><span data-id="element-1671" data-mp="1zq47nr6kg9sr">VAT</span><span data-id="element-1672" data-mp="2eh3dwvjxim96">SAR {tax.toFixed(2)}</span></div>
        </div>
      </header>
      <div className="divide-y divide-gray-100 px-3" data-id="element-1673" data-mp="2egbknrdt10m2">
        {items.map(item => <article key={item.id} className="flex items-center gap-3 py-3" data-id="element-1674" data-mp="29iicissxxwj5">
            <img src={item.image} alt={item.name} className="h-11 w-11 shrink-0 rounded-md bg-gray-50 object-cover" data-id="element-1675" data-mp="2nit3dvu93b4b" />
            <p className="min-w-0 flex-1 truncate text-xs font-medium text-gray-900" data-id="element-1676" data-mp="2jhr2zbolkt0r">{item.quantity}× {item.name}</p>
            <span className="shrink-0 text-xs font-bold text-gray-900" data-id="element-1677" data-mp="2qh9rh06egktv">SAR {item.price.toFixed(2)}</span>
          </article>)}
      </div>
      <footer className="border-t border-brand-border bg-brand-soft px-3 py-2.5" data-id="element-1678" data-mp="30h0md2yvh1uh">
        <p className="flex items-center gap-1 text-[11px] font-medium text-brand" data-id="element-1679" data-mp="3580ja87zrjwz"><PackageCheckIcon className="h-3.5 w-3.5" data-id="element-1680" data-mp="35adbrfbdlcoa" /> All items delivered together</p>
      </footer>
    </section>;
}